import { Editor as TiptapEditor } from "@tiptap/react"
import { DOMParser as ProseMirrorDOMParser, Slice } from "@tiptap/pm/model"
import { escapeHTML } from "utils/escapeHtml"

/**
 * Inserts plain questionnaire text at the cursor (`selection.from`) as one
 * paragraph per line, in a single transaction so one undo takes it all out.
 * Lines are HTML-escaped, so `<<B>> < 3` stays text; empty lines become
 * `<p><br></p>`, as in the AI conversion insert. White space is collapsed
 * the same way as when a questionnaire is loaded.
 *
 * @param editor - The questionnaire editor
 * @param text - The plain text to insert (`\n` or `\r\n` line ends)
 * @param at - A document position to insert at instead of the cursor
 */
export const insertTextAtCursor = (
  editor: TiptapEditor,
  text: string,
  at?: number
): void => {
  if (editor.isDestroyed) return

  const html = text
    .split(/\r?\n/)
    .map((line) =>
      line.trim() === "" ? "<p><br></p>" : "<p>" + escapeHTML(line) + "</p>"
    )
    .join("")

  const element = document.createElement("div")
  element.innerHTML = html
  const parsed = ProseMirrorDOMParser.fromSchema(editor.schema).parse(element)

  const { state, view } = editor
  const from = at ?? state.selection.from
  view.dispatch(
    state.tr
      .replaceRange(from, from, new Slice(parsed.content, 0, 0))
      .scrollIntoView()
  )
}
